// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--vCots","label":"style-module--label--2StYb"};